import { render, staticRenderFns } from "./MailRecipientScopeModal.vue?vue&type=template&id=72f92144&scoped=true"
import script from "./MailRecipientScopeModal.vue?vue&type=script&lang=js"
export * from "./MailRecipientScopeModal.vue?vue&type=script&lang=js"
import style0 from "./MailRecipientScopeModal.vue?vue&type=style&index=0&id=72f92144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f92144",
  null
  
)

export default component.exports